// import React from "react";

// const RecordsFilterBar = ({ viewMode, setViewMode }) => {
//   return (
//     <div className="pa2 bg-white shadow-3 br3 mb3">
//       <button onClick={() => setViewMode("all")}>All</button>
//       <button onClick={() => setViewMode("approved")}>Approved</button>
//       <button onClick={() => setViewMode("not_approved")}>Not Approved</button>
//       <button onClick={() => setViewMode("monthly")}>Monthly</button>
//       <button onClick={() => setViewMode("yearly")}>Yearly</button>
//     </div>
//   );
// };

// export default RecordsFilterBar;

import React from "react";

const RecordsFilterBar = ({
  viewMode,
  setViewMode,
}) => {
  const filters = [
    {
      key: "all",
      label: "All Records",
      icon: "📋",
    },
    {
      key: "approved",
      label: "Approved",
      icon: "✅",
    },
    {
      key: "not_approved",
      label: "Pending",
      icon: "⏳",
    },
    {
      key: "monthly",
      label: "Monthly",
      icon: "📅",
    },
    {
      key: "yearly",
      label: "Yearly",
      icon: "📈",
    },
  ];

  return (
    <div className="flex flex-wrap">
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() =>
            setViewMode(filter.key)
          }
          className={`ma1 br-pill bn pointer ph3 pv2 fw6 transition-all ${
            viewMode === filter.key
              ? "bg-dark-blue white"
              : "bg-near-white dark-gray"
          }`}
        >
          <span className="mr1">
            {filter.icon}
          </span>
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default RecordsFilterBar;